import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

const TONE_CLASS = {
  primary: "bg-primary/10 text-primary",
  success: "bg-emerald-500/10 text-emerald-600",
  warning: "bg-amber-500/10 text-amber-600",
  muted: "bg-muted/80 text-muted-foreground",
  info: "bg-blue-500/10 text-blue-600",
  violet: "bg-violet-500/10 text-violet-600",
};

const SummaryCard = ({
  title,
  value,
  subtitle,
  icon: Icon,
  tone = "primary",
  headerAccessory,
  action,
  actionAlignment = "end",
}) => (
  <Card className="h-full min-h-[96px] border-border/70 bg-card/95 py-3 shadow-sm">
    <CardContent className="flex h-full flex-col px-3">
      <div className="flex min-h-0 flex-1 flex-col">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0 flex-1 text-xs font-medium text-foreground">
            {title}
          </div>
          {headerAccessory ? (
            <div className="shrink-0">{headerAccessory}</div>
          ) : null}
        </div>
        <div className="mt-2 flex min-w-0 flex-1 items-center gap-2.5">
          <div
            className={cn(
              "flex h-10 w-10 shrink-0 items-center justify-center rounded-md",
              TONE_CLASS[tone],
            )}
          >
            {Icon ? <Icon className="h-5 w-5" /> : null}
          </div>
          <div className="min-w-0">
            <p className="text-xl font-semibold text-foreground">{value}</p>
            {subtitle != null && subtitle !== "" && !action && (
              <div className="mb-0 truncate text-[11px] text-muted-foreground">
                {subtitle}
              </div>
            )}
          </div>
        </div>
      </div>
      {action ? (
        <div
          className={cn(
            "mt-3 flex gap-3",
            subtitle != null && subtitle !== ""
              ? "items-center justify-between"
              : actionAlignment === "start"
                ? "justify-start"
                : "justify-end",
          )}
        >
          {subtitle != null && subtitle !== "" ? (
            <div className="min-w-0 flex-1 text-[11px] leading-5 text-muted-foreground line-clamp-2">
              {subtitle}
            </div>
          ) : null}
          <div className="shrink-0">{action}</div>
        </div>
      ) : null}
    </CardContent>
  </Card>
);

export default SummaryCard;
